import React from "react";
import {
  BookOpen, Book, Bookmark, Star, Heart, Sparkles,
  Globe, Crown, Baby, Users, UserCheck,
  Zap, Flame, Leaf, Sun, Moon, Music, Briefcase,
  Lightbulb, Smile, Shield, Compass, Feather, Eye,
} from "lucide-react";

/* ================= TYPES ================= */
export interface CategoryItem {
  id:               number;
  name:             string;
  icon:             React.ReactNode;
  parentId?:        number | null;
  superCategoryId?: number;
   image?: any;
}

/* ──────────────────────────────────────────────
   TOP-LEVEL BOOK CATEGORIES
   ────────────────────────────────────────────── */
export const idBooksCategories: CategoryItem[] = [
  { id: 301, superCategoryId: 3, name: "Fiction",                 icon: <BookOpen size={20} color="currentColor" />  },
  { id: 302, superCategoryId: 3, name: "Non-Fiction",             icon: <Lightbulb size={20} color="currentColor" /> },
  { id: 303, superCategoryId: 3, name: "Children's Books",        icon: <Baby size={20} color="currentColor" />      },
  { id: 304, superCategoryId: 3, name: "Young Adult",             icon: <Users size={20} color="currentColor" />     },
  { id: 305, superCategoryId: 3, name: "Academic & Textbooks",    icon: <Briefcase size={20} color="currentColor" /> },
  { id: 306, superCategoryId: 3, name: "Comics & Manga",          icon: <Smile size={20} color="currentColor" />     },
  { id: 307, superCategoryId: 3, name: "Arts & Photography",      icon: <Feather size={20} color="currentColor" />   },
  { id: 308, superCategoryId: 3, name: "Travel & Maps",           icon: <Compass size={20} color="currentColor" />   },
  { id: 309, superCategoryId: 3, name: "Religion & Spirituality", icon: <Sparkles size={20} color="currentColor" />  },
  { id: 310, superCategoryId: 3, name: "Languages",               icon: <Globe size={20} color="currentColor" />     },
  { id: 311, superCategoryId: 3, name: "Book Sets & Gifts",       icon: <Crown size={20} color="currentColor" />     },
];

/* ──────────────────────────────────────────────
   FICTION
   ────────────────────────────────────────────── */
export const idBooksFictionSubcategories: CategoryItem[] = [
  { id: 30101, parentId: 301, name: "Genre Fiction",    icon: <Book size={20} color="currentColor" />     },
  { id: 30102, parentId: 301, name: "Literary Fiction", icon: <Feather size={20} color="currentColor" />  },
  { id: 30103, parentId: 301, name: "Classic Fiction",  icon: <Bookmark size={20} color="currentColor" /> },
];

export const idBooksGenreFiction: CategoryItem[] = [
  { id: 3010101, parentId: 30101, name: "Romance",            icon: <Heart size={20} color="currentColor" />    },
  { id: 3010102, parentId: 30101, name: "Thriller & Crime",   icon: <Eye size={20} color="currentColor" />      },
  { id: 3010103, parentId: 30101, name: "Science Fiction",    icon: <Zap size={20} color="currentColor" />      },
  { id: 3010104, parentId: 30101, name: "Fantasy",            icon: <Sparkles size={20} color="currentColor" /> },
  { id: 3010105, parentId: 30101, name: "Horror",             icon: <Moon size={20} color="currentColor" />     },
  { id: 3010106, parentId: 30101, name: "Historical Fiction", icon: <Compass size={20} color="currentColor" />  },
  { id: 3010107, parentId: 30101, name: "Mystery",            icon: <Eye size={20} color="currentColor" />      },
  { id: 3010108, parentId: 30101, name: "Adventure",          icon: <Flame size={20} color="currentColor" />    },
  { id: 3010109, parentId: 30101, name: "Graphic Novels",     icon: <Smile size={20} color="currentColor" />    },
  { id: 3010110, parentId: 30101, name: "Short Stories",      icon: <BookOpen size={20} color="currentColor" /> },
];

export const idBooksLiteraryFiction: CategoryItem[] = [
  { id: 3010201, parentId: 30102, name: "Contemporary",    icon: <Feather size={20} color="currentColor" />  },
  { id: 3010202, parentId: 30102, name: "Magical Realism", icon: <Sparkles size={20} color="currentColor" /> },
  { id: 3010203, parentId: 30102, name: "Satire & Humour", icon: <Smile size={20} color="currentColor" />    },
];

export const idBooksClassicFiction: CategoryItem[] = [
  { id: 3010301, parentId: 30103, name: "Victorian",      icon: <Crown size={20} color="currentColor" />    },
  { id: 3010302, parentId: 30103, name: "20th Century",   icon: <BookOpen size={20} color="currentColor" /> },
  { id: 3010303, parentId: 30103, name: "World Classics", icon: <Globe size={20} color="currentColor" />    },
];

/* ──────────────────────────────────────────────
   NON-FICTION
   ────────────────────────────────────────────── */
export const idBooksNonFictionSubcategories: CategoryItem[] = [
  { id: 30201, parentId: 302, name: "Biography & Memoir",  icon: <UserCheck size={20} color="currentColor" /> },
  { id: 30202, parentId: 302, name: "Self-Help",           icon: <Sparkles size={20} color="currentColor" />  },
  { id: 30203, parentId: 302, name: "Health & Wellness",   icon: <Heart size={20} color="currentColor" />     },
  { id: 30204, parentId: 302, name: "Business & Finance",  icon: <Briefcase size={20} color="currentColor" /> },
  { id: 30205, parentId: 302, name: "Science & Nature",    icon: <Leaf size={20} color="currentColor" />      },
  { id: 30206, parentId: 302, name: "History & Politics",  icon: <Globe size={20} color="currentColor" />     },
  { id: 30207, parentId: 302, name: "Food & Drink",        icon: <Flame size={20} color="currentColor" />     },
  { id: 30208, parentId: 302, name: "Mind, Body & Spirit", icon: <Sun size={20} color="currentColor" />       },
];

export const idBooksBiography: CategoryItem[] = [
  { id: 3020101, parentId: 30201, name: "Autobiographies",   icon: <UserCheck size={20} color="currentColor" /> },
  { id: 3020102, parentId: 30201, name: "Biographies",       icon: <Book size={20} color="currentColor" />      },
  { id: 3020103, parentId: 30201, name: "Diaries & Letters", icon: <Feather size={20} color="currentColor" />   },
  { id: 3020104, parentId: 30201, name: "True Crime",        icon: <Eye size={20} color="currentColor" />       },
];

export const idBooksSelfHelp: CategoryItem[] = [
  { id: 3020201, parentId: 30202, name: "Motivation",       icon: <Zap size={20} color="currentColor" />       },
  { id: 3020202, parentId: 30202, name: "Mindfulness",      icon: <Sun size={20} color="currentColor" />       },
  { id: 3020203, parentId: 30202, name: "Relationships",    icon: <Heart size={20} color="currentColor" />     },
  { id: 3020204, parentId: 30202, name: "Productivity",     icon: <Sparkles size={20} color="currentColor" />  },
  { id: 3020205, parentId: 30202, name: "Finance & Wealth", icon: <Briefcase size={20} color="currentColor" /> },
];

export const idBooksBusiness: CategoryItem[] = [
  { id: 3020401, parentId: 30204, name: "Entrepreneurship", icon: <Flame size={20} color="currentColor" />     },
  { id: 3020402, parentId: 30204, name: "Management",       icon: <Briefcase size={20} color="currentColor" /> },
  { id: 3020403, parentId: 30204, name: "Investing",        icon: <Zap size={20} color="currentColor" />       },
  { id: 3020404, parentId: 30204, name: "Marketing",        icon: <Sparkles size={20} color="currentColor" />  },
  { id: 3020405, parentId: 30204, name: "Economics",        icon: <Globe size={20} color="currentColor" />     },
];

export const idBooksScience: CategoryItem[] = [
  { id: 3020501, parentId: 30205, name: "Popular Science",   icon: <Lightbulb size={20} color="currentColor" /> },
  { id: 3020502, parentId: 30205, name: "Nature & Wildlife", icon: <Leaf size={20} color="currentColor" />      },
  { id: 3020503, parentId: 30205, name: "Astronomy",         icon: <Sparkles size={20} color="currentColor" />  },
  { id: 3020504, parentId: 30205, name: "Technology & AI",   icon: <Zap size={20} color="currentColor" />       },
  { id: 3020505, parentId: 30205, name: "Environment",       icon: <Sun size={20} color="currentColor" />       },
];

export const idBooksFood: CategoryItem[] = [
  { id: 3020701, parentId: 30207, name: "Cookbooks",           icon: <Flame size={20} color="currentColor" />    },
  { id: 3020702, parentId: 30207, name: "Baking",              icon: <Sparkles size={20} color="currentColor" /> },
  { id: 3020703, parentId: 30207, name: "Wine & Spirits",      icon: <Leaf size={20} color="currentColor" />     },
  { id: 3020704, parentId: 30207, name: "Vegan & Plant-Based", icon: <Leaf size={20} color="currentColor" />     },
];

/* ──────────────────────────────────────────────
   CHILDREN'S BOOKS
   ────────────────────────────────────────────── */
export const idBooksChildrensSubcategories: CategoryItem[] = [
  { id: 30301, parentId: 303, name: "Baby & Toddler", icon: <Baby size={20} color="currentColor" />      },
  { id: 30302, parentId: 303, name: "Ages 3-7",       icon: <Smile size={20} color="currentColor" />     },
  { id: 30303, parentId: 303, name: "Ages 8-12",      icon: <BookOpen size={20} color="currentColor" />  },
  { id: 30304, parentId: 303, name: "Educational",    icon: <Lightbulb size={20} color="currentColor" /> },
];

export const idBooksBabyToddler: CategoryItem[] = [
  { id: 3030101, parentId: 30301, name: "Board Books",    icon: <Baby size={20} color="currentColor" />  },
  { id: 3030102, parentId: 30301, name: "Picture Books",  icon: <Smile size={20} color="currentColor" /> },
  { id: 3030103, parentId: 30301, name: "Nursery Rhymes", icon: <Music size={20} color="currentColor" /> },
  { id: 3030104, parentId: 30301, name: "Touch & Feel",   icon: <Heart size={20} color="currentColor" /> },
];

export const idBooksAges3to7: CategoryItem[] = [
  { id: 3030201, parentId: 30302, name: "Picture Books",  icon: <Smile size={20} color="currentColor" />    },
  { id: 3030202, parentId: 30302, name: "Early Readers",  icon: <BookOpen size={20} color="currentColor" /> },
  { id: 3030203, parentId: 30302, name: "Fairy Tales",    icon: <Sparkles size={20} color="currentColor" /> },
  { id: 3030204, parentId: 30302, name: "Activity Books", icon: <Zap size={20} color="currentColor" />      },
];

export const idBooksAges8to12: CategoryItem[] = [
  { id: 3030301, parentId: 30303, name: "Adventure", icon: <Compass size={20} color="currentColor" />  },
  { id: 3030302, parentId: 30303, name: "Fantasy",   icon: <Sparkles size={20} color="currentColor" /> },
  { id: 3030303, parentId: 30303, name: "Humour",    icon: <Smile size={20} color="currentColor" />    },
  { id: 3030304, parentId: 30303, name: "Mystery",   icon: <Eye size={20} color="currentColor" />      },
];

/* ──────────────────────────────────────────────
   YOUNG ADULT
   ────────────────────────────────────────────── */
export const idBooksYASubcategories: CategoryItem[] = [
  { id: 30401, parentId: 304, name: "Fantasy & Sci-Fi",   icon: <Sparkles size={20} color="currentColor" /> },
  { id: 30402, parentId: 304, name: "Romance",            icon: <Heart size={20} color="currentColor" />    },
  { id: 30403, parentId: 304, name: "Contemporary",       icon: <Feather size={20} color="currentColor" />  },
  { id: 30404, parentId: 304, name: "Thriller & Mystery", icon: <Eye size={20} color="currentColor" />      },
];

export const idBooksYAFantasy: CategoryItem[] = [
  { id: 3040101, parentId: 30401, name: "Epic Fantasy", icon: <Crown size={20} color="currentColor" />  },
  { id: 3040102, parentId: 30401, name: "Dystopian",    icon: <Shield size={20} color="currentColor" /> },
  { id: 3040103, parentId: 30401, name: "Paranormal",   icon: <Moon size={20} color="currentColor" />   },
  { id: 3040104, parentId: 30401, name: "Space Opera",  icon: <Zap size={20} color="currentColor" />    },
];

/* ──────────────────────────────────────────────
   ACADEMIC & TEXTBOOKS
   ────────────────────────────────────────────── */
export const idBooksAcademicSubcategories: CategoryItem[] = [
  { id: 30501, parentId: 305, name: "Science & Maths",    icon: <Lightbulb size={20} color="currentColor" /> },
  { id: 30502, parentId: 305, name: "Humanities",         icon: <Globe size={20} color="currentColor" />     },
  { id: 30503, parentId: 305, name: "Law",                icon: <Shield size={20} color="currentColor" />    },
  { id: 30504, parentId: 305, name: "Medicine & Nursing", icon: <Heart size={20} color="currentColor" />     },
  { id: 30505, parentId: 305, name: "Engineering",        icon: <Zap size={20} color="currentColor" />       },
  { id: 30506, parentId: 305, name: "IT & Computing",     icon: <Zap size={20} color="currentColor" />       },
];

/* ──────────────────────────────────────────────
   COMICS & MANGA
   ────────────────────────────────────────────── */
export const idBooksComicsSubcategories: CategoryItem[] = [
  { id: 30601, parentId: 306, name: "Marvel & DC",    icon: <Zap size={20} color="currentColor" />      },
  { id: 30602, parentId: 306, name: "Manga",          icon: <Smile size={20} color="currentColor" />    },
  { id: 30603, parentId: 306, name: "Graphic Novels", icon: <BookOpen size={20} color="currentColor" /> },
  { id: 30604, parentId: 306, name: "Indie Comics",   icon: <Feather size={20} color="currentColor" />  },
];

export const idBooksManga: CategoryItem[] = [
  { id: 3060201, parentId: 30602, name: "Shonen", icon: <Flame size={20} color="currentColor" />    },
  { id: 3060202, parentId: 30602, name: "Shojo",  icon: <Heart size={20} color="currentColor" />    },
  { id: 3060203, parentId: 30602, name: "Seinen", icon: <Eye size={20} color="currentColor" />      },
  { id: 3060204, parentId: 30602, name: "Josei",  icon: <Sparkles size={20} color="currentColor" /> },
  { id: 3060205, parentId: 30602, name: "Manhwa", icon: <BookOpen size={20} color="currentColor" /> },
];

/* ──────────────────────────────────────────────
   ARTS & PHOTOGRAPHY
   ────────────────────────────────────────────── */
export const idBooksArtsSubcategories: CategoryItem[] = [
  { id: 30701, parentId: 307, name: "Photography",           icon: <Eye size={20} color="currentColor" />     },
  { id: 30702, parentId: 307, name: "Architecture & Design", icon: <Compass size={20} color="currentColor" /> },
  { id: 30703, parentId: 307, name: "Fashion & Style",       icon: <Crown size={20} color="currentColor" />   },
  { id: 30704, parentId: 307, name: "Fine Art",              icon: <Feather size={20} color="currentColor" /> },
  { id: 30705, parentId: 307, name: "Music",                 icon: <Music size={20} color="currentColor" />   },
];

/* ──────────────────────────────────────────────
   TRAVEL & MAPS
   ────────────────────────────────────────────── */
export const idBooksTravelSubcategories: CategoryItem[] = [
  { id: 30801, parentId: 308, name: "Travel Guides",  icon: <Compass size={20} color="currentColor" /> },
  { id: 30802, parentId: 308, name: "Travel Writing", icon: <Feather size={20} color="currentColor" /> },
  { id: 30803, parentId: 308, name: "Maps & Atlases", icon: <Globe size={20} color="currentColor" />   },
];

export const idBooksTravelGuides: CategoryItem[] = [
  { id: 3080101, parentId: 30801, name: "Europe",      icon: <Globe size={20} color="currentColor" /> },
  { id: 3080102, parentId: 30801, name: "Asia",        icon: <Globe size={20} color="currentColor" /> },
  { id: 3080103, parentId: 30801, name: "Americas",    icon: <Globe size={20} color="currentColor" /> },
  { id: 3080104, parentId: 30801, name: "Africa",      icon: <Globe size={20} color="currentColor" /> },
  { id: 3080105, parentId: 30801, name: "Middle East", icon: <Globe size={20} color="currentColor" /> },
];

/* ──────────────────────────────────────────────
   RELIGION & SPIRITUALITY
   ────────────────────────────────────────────── */
export const idBooksReligionSubcategories: CategoryItem[] = [
  { id: 30901, parentId: 309, name: "Christianity", icon: <Sparkles size={20} color="currentColor" /> },
  { id: 30902, parentId: 309, name: "Islam",        icon: <Moon size={20} color="currentColor" />     },
  { id: 30903, parentId: 309, name: "Buddhism",     icon: <Sun size={20} color="currentColor" />      },
  { id: 30904, parentId: 309, name: "Spirituality", icon: <Star size={20} color="currentColor" />     },
  { id: 30905, parentId: 309, name: "New Age",      icon: <Sparkles size={20} color="currentColor" /> },
];

/* ──────────────────────────────────────────────
   LANGUAGES
   ────────────────────────────────────────────── */
export const idBooksLanguagesSubcategories: CategoryItem[] = [
  { id: 31001, parentId: 310, name: "Language Learning", icon: <Globe size={20} color="currentColor" />    },
  { id: 31002, parentId: 310, name: "Dictionaries",      icon: <BookOpen size={20} color="currentColor" /> },
  { id: 31003, parentId: 310, name: "Grammar & Writing", icon: <Feather size={20} color="currentColor" />  },
];

export const idBooksLanguageLearning: CategoryItem[] = [
  { id: 3100101, parentId: 31001, name: "English",  icon: <Globe size={20} color="currentColor" /> },
  { id: 3100102, parentId: 31001, name: "Spanish",  icon: <Globe size={20} color="currentColor" /> },
  { id: 3100103, parentId: 31001, name: "French",   icon: <Globe size={20} color="currentColor" /> },
  { id: 3100104, parentId: 31001, name: "German",   icon: <Globe size={20} color="currentColor" /> },
  { id: 3100105, parentId: 31001, name: "Italian",  icon: <Globe size={20} color="currentColor" /> },
  { id: 3100106, parentId: 31001, name: "Arabic",   icon: <Globe size={20} color="currentColor" /> },
  { id: 3100107, parentId: 31001, name: "Chinese",  icon: <Globe size={20} color="currentColor" /> },
  { id: 3100108, parentId: 31001, name: "Japanese", icon: <Globe size={20} color="currentColor" /> },
];

/* ──────────────────────────────────────────────
   BOOK SETS & GIFTS
   ────────────────────────────────────────────── */
export const idBooksGiftSets: CategoryItem[] = [
  { id: 31101, parentId: 311, name: "Fiction Sets",         icon: <BookOpen size={20} color="currentColor" /> },
  { id: 31102, parentId: 311, name: "Children's Sets",      icon: <Baby size={20} color="currentColor" />     },
  { id: 31103, parentId: 311, name: "Gift Boxes",           icon: <Crown size={20} color="currentColor" />    },
  { id: 31104, parentId: 311, name: "Collector's Editions", icon: <Star size={20} color="currentColor" />     },
];

/* ──────────────────────────────────────────────
   AGGREGATE EXPORTS
   ────────────────────────────────────────────── */
export const idBooksSubcategories: CategoryItem[] = [
  ...idBooksFictionSubcategories,
  ...idBooksNonFictionSubcategories,
  ...idBooksChildrensSubcategories,
  ...idBooksYASubcategories,
  ...idBooksAcademicSubcategories,
  ...idBooksComicsSubcategories,
  ...idBooksArtsSubcategories,
  ...idBooksTravelSubcategories,
  ...idBooksReligionSubcategories,
  ...idBooksLanguagesSubcategories,
];

export const idBooksProducts: CategoryItem[] = [
  ...idBooksGenreFiction,
  ...idBooksLiteraryFiction,
  ...idBooksClassicFiction,
  ...idBooksBiography,
  ...idBooksSelfHelp,
  ...idBooksBusiness,
  ...idBooksScience,
  ...idBooksFood,
  ...idBooksBabyToddler,
  ...idBooksAges3to7,
  ...idBooksAges8to12,
  ...idBooksYAFantasy,
  ...idBooksManga,
  ...idBooksTravelGuides,
  ...idBooksLanguageLearning,
  ...idBooksGiftSets,
];